var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade"}},[(_vm.showing)?_c('div',{staticClass:"fixed py-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-30"},[_c('div',{staticClass:"mx-2 w-10/12 lg:w-2/4 max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }